// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Policy & legal settings  (customer side)
// The PUBLISHED version of one legal document, if staff have published one: "loading" until the answer arrives, "none" when there is no published version (or the request failed, so the built-in
// text shows), "ready" with the document. A legal page must never flash the wrong text, so the pages show a placeholder while "loading".
// Neighbours: utils/policyDocs, pages/TermsAndConditions, pages/PrivacyPolicy, pages/PolicyDocument.
// ─────────────────────────────────────────────────────────────────────────────
import { useEffect, useState } from "react";
import { fetchPublicPolicy, type PublicPolicyFull } from "../utils/policyDocs";

export type PublishedState = { status: "loading" } | { status: "none" } | { status: "ready"; doc: PublicPolicyFull };

export default function usePublishedPolicy(slug: string): PublishedState {
  const [state, setState] = useState<PublishedState>({ status: "loading" });
  useEffect(() => {
    let live = true;
    setState({ status: "loading" });
    fetchPublicPolicy(slug).then((doc) => live && setState(doc ? { status: "ready", doc } : { status: "none" }), () => live && setState({ status: "none" }));
    return () => { live = false; };
  }, [slug]);
  return state;
}
